var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
        _vm.baseClass,
        _vm.colsClass,
        _vm.wrapsClass,
        _vm.directionClass,
        _vm.justifyClass,
        _vm.alignClass ],style:({ marginLeft: ("-" + (Number(_vm.gutter) / 2) + "px"), marginRight: ("-" + (Number(_vm.gutter) / 2) + "px") }),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }